module.exports = __webpack_public_path__ + "static/media/growth_icon.2a8bf20f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/growth_icon.svg
// module id = 1185
// module chunks = 0